var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._b({},'div',_vm.$attrs,false),_vm._l((_vm.user.socialLinks),function(ref){
var icon = ref.icon;
var name = ref.name;
var url = ref.url;
return _c('v-btn',{key:name,attrs:{"icon":"","link":"","href":url,"target":"_blank","rel":"noreferrer","aria-label":name}},[_c('v-icon',[_vm._v(_vm._s(icon))])],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }